import { render, staticRenderFns } from "./EqifyBootstrapTypeahead.vue?vue&type=template&id=38b602a1&scoped=true"
import script from "./EqifyBootstrapTypeahead.vue?vue&type=script&lang=js"
export * from "./EqifyBootstrapTypeahead.vue?vue&type=script&lang=js"
import style0 from "./EqifyBootstrapTypeahead.vue?vue&type=style&index=0&id=38b602a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b602a1",
  null
  
)

export default component.exports